import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppContext } from '../contexts/AppContext';

/**
 * Handles auth-based redirects:
 * - Authenticated paid-tier users are redirected away from /login and /signup to /stories
 * - Guest tier users can still access /signup to choose a paid tier
 * - Unauthenticated users trying to access protected routes can be redirected (future use)
 *
 * Must only be called inside a route component (needs useNavigate).
 */
export function useAuthRedirect() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, isAuthResolved, userTier } = useAppContext();

  useEffect(() => {
    // Wait for auth state to resolve before making redirect decisions
    if (!isAuthResolved) return;

    const pathname = location.pathname;

    // Redirect authenticated paid-tier users away from login/signup
    if (isAuthenticated && (pathname === '/login' || pathname === '/signup')) {
      const hasPaidTier = userTier === 'starter' || userTier === 'reader' || userTier === 'ultra';
      if (hasPaidTier) {
        navigate('/stories', { replace: true });
      }
    }
  }, [isAuthenticated, isAuthResolved, userTier, location.pathname, navigate]);
}
